import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApisService } from '@core/services/apis.service';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
@Component({
  selector: 'app-add-m-countries',
  templateUrl: './add-m-countries.component.html',
  styleUrls: ['./add-m-countries.component.scss']
})
export class AddMCountriesComponent implements OnInit {

 
   
    
    
      
    
      formData: any = {
       name_ar: '',
       name_en: '',
      };
    
   
    
    
    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private apiService: ApisService,
        private toastr: ToastrService,
         private translate: TranslateService
      ) {}
        ngOnInit(): void {
        // get product id from route         
            
      }
     
   onSubmit(): void {
     const form = new FormData();
     form.append('name_en', this.formData.name_en);
     form.append('name_ar', this.formData.name_ar);
   
     this.apiService.addCountriesM(form).subscribe({
       next: () => {
         this.toastr.success(this.translate.instant('MENU.DASHBOARD.countries_added_successfully'));
         this.router.navigate(['/m-countries']);
       },
       error: (err) => {
         console.error('Add countries failed:', err);
         this.toastr.error(this.translate.instant('MENU.DASHBOARD.failed_to_add_countries'));
       }
     });
   }
   
    
    cancel(): void {
       this.router.navigate(['/m-countries']);
     }
   
 

}
